import { createRoute } from "@tanstack/react-router";
import { withPermission } from "../lib/with-permission";
import { rootRoute } from "./__root";
import { OfferFormPage } from "./offers.new";

function OrderEditPage() {
	const { id } = route.useParams();
	return <OfferFormPage orderId={id} />;
}

export const route = createRoute({
	getParentRoute: () => rootRoute,
	path: "/orders/$id/edit",
	component: withPermission(OrderEditPage, "orders", "update"),
});
